import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-400 py-3">
      <div className="container mx-auto text-center">
        <p className="text-sm text-gray-300">
          &copy; 2024 Plantão Fácil. Todos os direitos reservados.
        </p>
        <p className="text-xs mt-1 text-gray-400">
          Feito com <span className="text-red-500">❤️</span> pela equipe Plantão
          Fácil.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
